import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { get, isEqual, find } from 'lodash';
import {
    EDIT_MERCHANT_FAILURE,
    EDIT_MERCHANT_LOAD,
    EDIT_MERCHANT_SUCCESS,
    MERCHANTS_FAILURE,
    MERCHANTS_LOAD,
    MERCHANTS_SUCCESS
} from './merchantManagementActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case EDIT_MERCHANT_FAILURE:
            newState = {
                ...state,
                editMerchantError: action.error,
                isEditMerchantLoading: false,
                isMerchantsLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_MERCHANT_LOAD:
            newState = {
                ...state,
                editMerchantError: null,
                isEditMerchantLoading: true,
                isEditMerchantSuccessful: false,
                isMerchantsLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_MERCHANT_SUCCESS:
            newState = {
                ...state,
                isEditMerchantLoading: false,
                isEditMerchantSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case MERCHANTS_LOAD:
            newState = {
                ...state,
                isMerchantsLoading: true,
                isMerchantsLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case MERCHANTS_SUCCESS:
            newState = {
                ...state,
                count: action.count,
                pages: action.pages,
                merchants: action.merchants,
                isMerchantsLoading: false,
                isMerchantsLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        case MERCHANTS_FAILURE:
            newState = {
                ...state,
                count: 0,
                isMerchantsLoading: false,
                pages: 0,
                merchants: [],
                isMerchantsLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getMerchantManagementEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'merchantManagement')
);

export const getIsEditMerchantLoading = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'isEditMerchantLoading')
);

export const getIsEditMerchantSuccessful = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'isEditMerchantSuccessful')
);

export const getEditMerchantError = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'editMerchantError')
);

export const getEditMerchantErrorMessage = createSelector(
    getEditMerchantError,
    (error) => get(error, 'message')
);

export const getCount = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'count')
);

export const getPages = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'pages')
);

export const getMerchants = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'merchants')
);

export const getMerchantByMerchantId = createSelector(
    getMerchants,
    (state, merchantId) => (merchantId),
    (merchants, merchantId) => (
        find(merchants, (merchant) => (merchant.merchantId === merchantId))
    )
);

export const getIsMerchantsLoading = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'isMerchantsLoading')
);

export const getIsMerchantsLoaded = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'isMerchantsLoaded')
);

export const getMerchantsError = createSelector(
    getMerchantManagementEntity,
    (entity) => get(entity, 'merchantsError')
);

export const getMerchantsErrorMessage = createSelector(
    getMerchantsError,
    (error) => get(error, 'message')
);
